import { Button, Modal } from 'react-bootstrap';

//import { Html5QrcodeScanner } from "html5-qrcode";
import { Html5Qrcode } from "html5-qrcode";

import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import http from "../Services/httpService";
//import Services from "../Services/Services";
//import { toast } from "react-toastify";
//import ConfirmDialog from './ConfirmDialog'
export default function QrCodeGet({ isBusy, handleClose, show, onChoice }) {
    const [scannedCode, setScannedCode] = useState('');
    const readerRef = useRef(null);
    const config = {
        fps: 10,    // Optional, frame per seconds for qr code scanning
        qrbox: { width: 250, height: 250 }  // Optional, if you want bounded box UI
    };
    /*
    useEffect(() => {       
        let html5QrcodeScanner = new Html5QrcodeScanner("reader", config, false);
        html5QrcodeScanner.render(onScanSuccess, onScanFailure);
    }, []);
       const onScanSuccess = (decodedText, decodedResult) => {
        console.log(`Code matched = ${decodedText}`, decodedResult);
    }
    const onScanFailure = (error) => {
        console.warn(`Code scan error = ${error}`);
    }
    */

    const [selectedCameraId, setSelectedCameraId] = useState(0)
    const [cameras, setCameras] = useState([])
    useEffect(() => {
        //if (cameras.length > 0)
        //    return;
        Html5Qrcode.getCameras().then(devices => {
            console.log('devices', devices)
            /*  { id: "id", label: "label" }    */
            if (devices && devices.length) {
                const backCamera = devices.find(
                    (d) =>
                        d.label.toLowerCase().includes("back") ||
                        d.label.toLowerCase().includes("rear")
                );
                if (backCamera)
                    setSelectedCameraId(backCamera.id);
                else
                    setSelectedCameraId(devices[0].id);
                setCameras(devices);
            }
        }).catch(err => { });
    }, [])

    const qrCodeRef = useRef(null);
    const isRunningRef = useRef(false);
    useEffect(() => {
        if (!show || cameras.length === 0 || !readerRef.current)
            return;
        const qrCode = new Html5Qrcode(readerRef.current.id);
        qrCodeRef.current = qrCode;
        qrCode.start(selectedCameraId, config,
            (decodedText, decodedResult) => {
                console.log(`Code matched = ${decodedText}`, decodedResult);

                try {
                    const url = new URL(decodedText);
                    const code = url.searchParams.get("code"); // مقدار 12345
                    console.log("Extracted code:", code);
                    setScannedCode(code);
                    isRunningRef.current = false;
                    try {
                        qrCode.stop().then(() => {
                            //console.log('close 1') 
                        }).catch((e) => { console.log('error close1', e) });
                    } catch { }
                    onChoice(code);
                } catch (err) {
                    console.error("Invalid QR text", err);
                    //onChoice(decodedText);
                }

            },
            (errorMessage) => {
                if (errorMessage!="QR code parse error, error = NotFoundException: No MultiFormat Readers were able to detect the code.")
                 console.log(`errorMessage`, errorMessage); 
                })
            .then(() => { isRunningRef.current = true; })
            .catch((err) => { console.log(`error`, err); });
        return () => {
            if (isRunningRef.current && qrCodeRef.current) {
                try {
                    qrCodeRef.current.stop().then(() => { console.log('close 2') }).catch((e) => { console.log('error close2', e) });
                } catch { }
                isRunningRef.current = false;
            }
        };
    }, [cameras, show, selectedCameraId])

    const doHandleClose = (e) => {
        if (isRunningRef.current && qrCodeRef.current)
            console.log('qrCodeRef.current', qrCodeRef.current);
        /*
            qrCodeRef.current.stop()
            .then((ignore) => {
               console.log('close 3')
            }).catch((err) => {
                console.log('error close 3',err)
            });*/
        handleClose();
    }
    return (

        <Modal show={show} centered onHide={doHandleClose} scrollable  >
            <Modal.Header closeButton>
                <Modal.Title className="colorRed">اسکن بارکد</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {scannedCode && <p>بارکد اسکن‌شده: {scannedCode}</p>}
                <select
                    className='mb-3'
                    onChange={(e) => setSelectedCameraId(e.target.value)}>
                    {cameras.map((cam) => (
                        <option key={cam.id} value={cam.id}>
                            {cam.label}
                        </option>
                    ))}
                </select>
                <div id="reader" ref={readerRef} width="600px"></div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
}


